/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'xing': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#00605e" d="M0 0h32v32H0V0z"/><path pid="1" _fill="#fff" d="M11.369 8.721H6.267l2.855 5.336-3.885 6.413h5.102l3.885-6.413zM21.387 4.648h5.376l-7.911 13.903 5.189 8.8h-5.369l-5.196-8.8z"/>'
  }
})
